import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';
import { SearchCollection } from './interfaces/search.interface';
import { SearchComponent } from './search.component';

@Component({
  selector: 'app-search-modal',
  imports: [SearchComponent],
  template: ` <app-search [collections]="collections()" (closed)="close()" /> `,
})
export class SearchModalComponent {
  private dialoRef = inject(DynamicDialogRef);
  private router = inject(Router);
  constructor() {
    // intercetto anche gli eventi di navigazione scatenati da eventuali link interni che portano ad una pagina di dettaglio.
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        this.close();
      });
  }
  collections = signal<SearchCollection[]>([
    {
      label: $localize`Contacts`,
      value: 'contacts',
      weight: 1,
      color: '--color-soe-twilight-blue',
    },
    {
      label: $localize`Real Estates`,
      value: 'real-estates',
      weight: 1,
      color: '--color-soe-orange-glow',
    },
    {
      label: $localize`Suppliers`,
      value: 'suppliers',
      weight: 1,
      color: '--color-soe-ocean-blue',
    },
    {
      label: $localize`Employees`,
      value: 'employees',
      weight: 1,
      color: '--color-soe-orchid-purple',
    },
    {
      label: $localize`Notes`,
      value: 'notes',
      weight: 1,
      color: '--color-soe-dark-gray',
    },
    {
      label: $localize`Activities`,
      value: 'activities',
      weight: 1,
      color: '--color-soe-dark-gray',
    },
    {
      label: $localize`Tasks`,
      value: 'tasks',
      weight: 1,
      color: '--color-soe-dark-gray',
    },
    {
      label: $localize`Documents`,
      value: 'document-assets',
      weight: 1,
      color: '--color-soe-light-gray',
    },
  ]);
  close() {
    this.dialoRef.close();
  }
}
export const SearchModalOptions: DynamicDialogConfig = {
  height: '50%',
  styleClass: 'w-full sm:w-2/3 lg:w-3/5 xl:w-2/5 3xl:w-1/4',
  showHeader: false,
  header: '',
  modal: true,
  dismissableMask: true,
  closeOnEscape: true,
  style: {
    '--p-dialog-content-padding': 0,
  },
};
